export const environment = {
  production: true,
  API_URL: 'https://app.mygeo.team',
  FORGOT_URL: 'https://app.mygeo.team/auth/recovery',
  REGISTRATION_URL: 'https://app.mygeo.team/auth/registration',
  REFRESH_TOKEN_TIMER: 1500000,
  SENTRY_DNS: 'https://05de2a5e47754605a23eb5cd23a9bce6@sentry.teamlead.com/50',
  hmr: false
};
